import * as React from "react";
import { useProvider } from "../Context";
import "dayjs/locale/ja";
import dayjs from "dayjs";
dayjs.locale("ja");

const initialState = {
  filteredDateFrom: dayjs().subtract(1, "month"),
  filteredDateTo: dayjs(),
  posiNegaTab: "all",
};

function reducer(state, { type, payload }) {
  switch (type) {
    case "set":
      return { ...state, ...payload };
    default:
      throw new Error("Action type not found");
  }
}

export function useFilterReducer() {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  return {
    state,
    dispatch,
  };
}

export default function () {
  const {
    filter: { state, dispatch },
  } = useProvider();

  function setFilteredDateFrom(date) {
    dispatch({
      type: "set",
      payload: { filteredDateFrom: date },
    });
  }
  function setFilteredDateTo(date) {
    dispatch({
      type: "set",
      payload: { filteredDateTo: date },
    });
  }
  function setPosiNegaTab(data) {
    dispatch({
      type: "set",
      payload: { posiNegaTab: data },
    });
  }
  return {
    state: state,
    dispatch: dispatch,
    setFilteredDateFrom,
    setFilteredDateTo,
    setPosiNegaTab,
  };
}
